module.exports = "/images/ebraun.png?6430493acdaa293c57c9beeeaf26b2e6";